import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import heroBg from "../../assets/nexhero.jpg"; // Update path as needed

function Hero() {
  return (
    <section
      className="hero d-flex align-items-center" id='hero'
      style={{
        backgroundImage: `linear-gradient(
      180deg,
    rgba(0, 0, 0, 0.55),
      rgba(0, 0, 0, 0.55)
    ),url(${heroBg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        minHeight: "100vh",
        width: "100%",
        position: "relative",
      }}
    >
      <Container>
        <Row className="align-items-center g-5">
          {/* Left Column */}
          <Col xs={12} lg={6} className="leftlgimg">
            <div className="eyebrow" style={{color:'var(--gold)'}}>
              Regulation D — Rule 506(c) Offering
            </div>

            <h1 style={{fontSize:'4rem'}}>
              Intelligent Operations.
              <br />
              <em style={{color:'var(--gold)'}}>Built for the Next<br/>
              Generation of Business.</em>
            </h1>

            <p className="hero-copy">
              A modern wordmark using a geometric N formed from two connected pathways, representing the company's core idea of connecting data, people, and AI-powered workflows. The visual identity should feel sophisticated, enterprise-focused, and technology-forward rather than overly "AI-themed."
            </p>

            <div className="hero-actions d-flex flex-wrap gap-3">
              <a href="#offering" className=""style={{color:"var(--white)"}}>
                Offering Terms
              </a>

              <a href="#why" className="btn-secondary">
                Why Invest
              </a>

              <a href="#offering" className="btn-primary">
                Invest Now
              </a>
            </div>
          </Col>

          {/* Right Column */}
          <Col
            xs={12}
            lg={6}
            className="narrative-card asset-dossier-card fade-up leftlgimg"
          >
                      <div className="hero-stats fade-up rounded"
                   
                      >
              <div className="stat-box">
                <div className="stat-value">$200M</div>
                <div className="stat-label" style={{color:"var(--white)"}}>Maximum Offering</div>
              </div>

              <div className="stat-box">
                <div className="stat-value">$50K</div>
                <div className="stat-label" style={{color:"var(--white)"}}>Minimum Investment</div>
              </div>

              <div className="stat-box" >
                <div className="stat-value">8–12%</div>
                <div className="stat-label" style={{color:"var(--white)"}}>Target Annual Return</div>
              </div>
            </div>

            <div className="raise-wrap fade-up rounded">
              <div className="raise-head">
                <span>Capital Raised</span>
                <strong>$47.3M</strong>
              </div>

              <div className="progress-track">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow={23.65}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  style={{ width: "23.65%" }}
                />
              </div>

              <div className="raise-foot">
                <span>23.65% of $200M maximum</span>
                <span>183 Accredited Investors</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Hero;